module.exports = __webpack_public_path__ + "static/media/mysticdiva_768.52f38ce6.jpg";